// extracted by mini-css-extract-plugin
export default {"zoomModal":"m2-z","image":"n2-z","button":"o2-z","isOverlayShown":"p2-z"};